import '../../sass/layout/page/page-news.scss';


import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay,  EffectFade} from 'swiper/modules';

const swiperNews = document.querySelector('.section-carousel');

if(swiperNews) {
    const carousel = swiperNews.querySelector('.swiper');
    const pagination = swiperNews.querySelector('.swiper-pagination');
    const prevEl = swiperNews.querySelector('.swiper-button-prev');
    const nextEl = swiperNews.querySelector('.swiper-button-next');
    const swiper = new Swiper(carousel, {
        modules: [Pagination, Navigation, Autoplay, EffectFade],
        loop: false,
        speed: 1200,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: pagination,
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
    })  
}
